import axios from "axios";
import Vue from 'vue'
// vue.$login.show()
// import qs from 'qs'
// import router from '@/router'
// var url = 'test-sdkapi.gamedachen.com' //打包切换后台地址  测试地址

// function getQueryString(name) {
//     const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
//     const urlObj = window.location;
//     var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
//     if (r != null) return unescape(r[2]);
//     return null;
// }
// var osType = getQueryString('osTye')

// var url = 'http://192.168.1.240:8080' //代理地址
// var url = '/api' //代理地址
// var url = 'http://192.168.0.55:8080' // 后台接口域名

// var url = 'https://test-sdkapi.gamedachen.com' //打包切换后台地址  测试地址
var url = 'https://sdkapi.gamedachen.com' //打包切换后台地址  测试地址

// var pro_url = ''
const service = axios.create({
    baseURL: url,
    timeout: 10000,
    headers: { 'Content-Type': 'application/json' }
})

service.defaults.withCredentials = true
    // http request 拦截器
service.interceptors.request.use(
    config => {
        // console.log(config)
        config.dataType = 'JSONP'
        return config
    },
    err => {
        return Promise.reject(err)
    })

// function outmessage(str) {
//     if (osType == 1) {
//         try {
//             window.SDK.outmessage(res.data.data);
//         } catch {
//             console.log(error)
//         }
//     } else if (osType == 2) {
//         try {
//             window.webkit.messageHandlers.outmessage.postMessage(res.data.data);
//         } catch {
//             console.log(error)
//         }
//     }
// }
// http response 拦截器
service.interceptors.response.use(
    response => {
        //拦截响应，做统一处理 
        if (response.data.code) {
            switch (response.data.code) {
                case 200:
                    break;
                default:
                    Vue.prototype.$Message.show(response.data.message)
                    break;
            }
        }
        return response
    },
    //接口错误状态处理，也就是说无响应时的处理
    error => {
        Vue.prototype.$Message.show('网络出现问题了哦')
        return Promise.reject(error.response) // 返回接口返回的错误信息
    })


// "deviceId": "865166023052155"
// 865166833052155
// 渠道号 de80e7105f704dfa81fa3edefd8e74c1
// http://192.168.0.45:8080/?userName=dcyk&deviceId=865166833052155&channelId=de80e7105f704dfa81fa3edefd8e74c1&headIcon=https%3A%2F%2Fdss3.bdstatic.com%2F70cFv8Sh_Q1YnxGkpoWK1HF6hhy%2Fit%2Fu%3D1107263072,1224997471&fm=26&gp=0.jpg
// http://test-app.gamedachen.com/?userName=dcyk&deviceId=865184634052155&channelId=de80e7105f704dfa81fa3edefd8e74c1&headIcon=https%3A%2F%2Fdss0.bdstatic.com%2F70cFuHSh_Q1YnxGkpoWK1HF6hhy%2Fit%2Fu%3D1712216034,2924212808&fm=111&gp=0.jpg


export default service